import { digObject } from '@domain-group/javascript-utils'

import { Grid, Image } from '@domain-group/suit-theme'

interface ImageGridProps {
  downloadPath: string,
  entityArray: object[],
  urlPath: string,
}

const ImageGrid = (props: ImageGridProps) => {
  const { entityArray, urlPath, downloadPath } = props

  return (
    <Grid
      // @ts-expect-error TS2322
      gridColumnGap="small"
      gridRowGap="small"
      gridTemplateColumns="repeat(auto-fill, minmax(150px, 1fr))"
      gridTemplateRows="repeat(auto-fill, minmax(150px, 1fr))"
    >
      {entityArray.map(entity => (
        <Image
          boxProps={{ border: '1px solid', borderColor: 'lineColor', borderRadius: '5px' }}
          forwardProps={{ as: 'a', href: digObject(entity, downloadPath, ''), target: '_blank' }}
          height={160}
          width={160}
          url={digObject(entity, urlPath, '')}
        />
      ))}
    </Grid>
  )
}

export default ImageGrid
